import features from './cmd/features';
import man from './cmd/man';

export default {
  features: features,
  man: man,
};
